import * as validator from 'validator'
import { v4 as uuidv4 } from 'uuid'
import { REACT_APP_READER_URL } from 'env'

export const checkUrl = (str: string) => validator.isURL(str)
export const proxyUrl = (url: string) => `${REACT_APP_READER_URL}/proxy/image?url=${encodeURIComponent(url)}`

export type FileError = 'invalid' | 'error'
export const validateMimeType = async (url: string, accept: string): Promise<FileError | undefined> => {
  try {
    const res = await fetch(proxyUrl(url), { method: 'HEAD' })
    const contentType = res.headers.get('Content-Type')

    if (!res.ok) return 'error'
    if (!contentType) return 'invalid'

    if (accept.includes(contentType)) {
      return
    } else {
      return 'invalid'
    }
  } catch (error) {
    return 'error'
  }
}

interface FetchFileProps {
  url: string
  filename?: string
  mimeType?: string
}
export const fetchFile = async ({ url, filename, mimeType }: FetchFileProps) => {
  const response = await fetch(proxyUrl(url))
  const contentType = response.headers.get('Content-Type')
  const blob = await response.blob()

  const parsedUrl = new URL(url)
  const parsedFilename = parsedUrl.pathname.split('/').pop()
  const name = parsedFilename || filename || uuidv4()
  const type = contentType || blob.type || mimeType

  return new File([blob], name, { type })
}
